/**
 * Client for the content-server's region-registry endpoint (/<tenant>/actions/regionInfo).
 */

// Fetch region map from main content-server
// Returns [{ regionId.toLowerCase(): origin }, ...]; rejects on any failure.
function loadRegionMap(usContentUrl) {
    const regionInfoUrl = usContentUrl + "/actions/regionInfo";
    return fetch(regionInfoUrl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include"
    })
    .then(function (res) {
        if (!res.ok) throw new Error("region-info fetch failed: " + res.status);
        return res.json();
    })
    .then(function (regionInfo) {
        if (!regionInfo?.regions) {
            throw new Error("region-info response has no regions");
        }
        return regionInfo.regions;
    });
}

module.exports = {
    loadRegionMap: loadRegionMap
};
